import useAdminDataStore, { selectCurrentGroupData } from "../store/adminData/adminData";

const useDashboardInfo = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const pathName = window.location.pathname;
  const dashboardType = pathName.split("/")[1]; // admin, clubadmin, superadmin
  const isRegForm = /\/[A-Za-z0-9%]*\/join/.test(pathName);
  const isAdminPath = /\/admin\/[A-Za-z0-9%]*/.test(pathName);
  const isClubAdminPath = /\/clubadmin\/[A-Za-z0-9%]*/.test(pathName);

  return {
    isParent: (dashboardType === "clubadmin" && groupData?.isParent) || false,
    dashboardType,
    isRegForm,
    isAdminPath,
    isClubAdminPath,
    pathName,
  };
};

export default useDashboardInfo;
